import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle, AlertCircle } from 'lucide-react';
import { api } from '../../utils/api';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (sessionId) pollPaymentStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const pollPaymentStatus = async () => {
    if (attempts >= 5) { setStatus('timeout'); return; }
    try {
      const result = await api(`/api/payments/status/${sessionId}`);
      if (result.payment_status === 'paid') { setStatus('success'); }
      else { setAttempts(prev => prev + 1); setTimeout(pollPaymentStatus, 2000); }
    } catch { setStatus('error'); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="card p-8 max-w-md w-full text-center" data-testid="payment-success-page">
        {status === 'checking' && (
          <>
            <Loader2 className="w-16 h-16 text-white animate-spin mx-auto mb-4" />
            <h2 className="font-heading text-2xl font-bold text-white mb-2">Processing Payment</h2>
            <p className="text-gray-400">Please wait while we confirm your payment...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h2 className="font-heading text-2xl font-bold text-white mb-2">Payment Successful!</h2>
            <p className="text-gray-400 mb-6">Thank you for your payment. Your invoice has been marked as paid.</p>
            <Link to="/customer/invoices" className="btn-primary" data-testid="back-to-invoices-btn">Back to Invoices</Link>
          </>
        )}
        {(status === 'error' || status === 'timeout') && (
          <>
            <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="font-heading text-2xl font-bold text-white mb-2">Payment Status Unknown</h2>
            <p className="text-gray-400 mb-6">We couldn't confirm your payment status. Please check your invoices.</p>
            <Link to="/customer/invoices" className="btn-primary" data-testid="check-invoices-btn">Check Invoices</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
